import ReelGroup from "./ReelGroup";
import GameEvents from "../const/GameEvents";
import SpinModel from "../model/SpinModel";
import { TweenMax } from "gsap";
import ReelCascadeArrangeBehaviour from "../spinners/ReelCascadeArrangeBehaviour";
import GameModel from "../model/GameModel";
// import ControllerManager from "../../../vendor_core/core/src/utils/ControllerManager";
import { IWinData } from "../server/data/ISpinData";
import SceneView from "./SceneView";
import App from "../App";

class CascadeReelGroup extends ReelGroup {
    public spinners: ReelCascadeArrangeBehaviour[];
    public popAnimationSprites: PIXI.extras.AnimatedSprite[] = [];
    public poppedSymbols = [];
    public isRespin: boolean = false;
    public reelsCascading: number = 0;
    public lastRemovedSymbols: boolean[];

    protected inCascade = false;
    protected spinStartTime = 0;

    constructor() {
        super();
    }

    public create(
        scene: SceneView,
        symbolData?: any[][],
        groupConfig?: {
            winLineLayer?: string;
            celеbrationLayer?: string;
            winSymbolsLayer?: string;
            reelExtraSymbols?: number;
        }
    ) {
        let noExtraConfig = {
            reelExtraSymbols: 0,
        };

        super.create(
            scene,
            symbolData,
            groupConfig
                ? Object.assign({}, groupConfig, noExtraConfig)
                : noExtraConfig
        );
    }

    public spin() {
        // To avoid possible issues
        TweenMax.killDelayedCallsTo(this.stopReels);

        // Clean props
        this.hasAnticipation = false;
        this.spinDelayedCalls = [];
        this.reelsSpinning = 0;
        this.reelsCascading = 0;
        this.isMinSpinTimeComplete = false;
        this.stopSymbolsAvailable = false;
        this.stoppingStarted = false;
        this.stopDelayedCalls = [];
        SpinModel.stopImmediately = false;

        // Start the spinning
        let delay = 0;
        this.spinStartTime = Date.now();
        this.spinners.forEach((spinner, reelIdx) => {
            delay +=
                reelIdx *
                this.config.cascadeAnimation.reelDelayTime *
                (this.inCascade ? 0 : 1);

            spinner.animationStartDelay = delay;
            this.reelsSpinning++;
            this.reelsCascading++;
            this.reels[reelIdx].on(
                GameEvents.CASCADE_STOPPED,
                this.onReelCascade,
                this
            );
        });

        this.spinners.forEach((spinner, reelIdx) => {
            spinner.spin();
        });

        // Set the delay for stopping
        let reelDelay = this.config.minSpinTime;
        if (GameModel.turboSpin) {
            reelDelay = this.config.quickSpinTime;
        }

        if (this.inCascade) {
            reelDelay = 0.5;
        }

        // this.addDelayedCall(reelDelay, this.allowStop, [], this);
    }

    public cascade() {

        this.inCascade = true;

        this.spin();
    }

    public onReelCascade(reelIdx: number) {
        this.reelsCascading--;
        const reel = this.reels[reelIdx];
        reel.off(
            GameEvents.CASCADE_STOPPED,
            this.onReelCascade,
            this
        );
        if (this.reelsCascading == 0) {

            let spinTime = Date.now();
            let reelDelay = this.config.minSpinTime;
            if (GameModel.turboSpin) {
                reelDelay = this.config.quickSpinTime;
            }
    
            if (this.inCascade) {
                reelDelay = 0.5;
            }

            let remainingTime = this.spinStartTime + reelDelay*1000 - spinTime;

            if (
                !this.stoppingStarted &&
                this.reelsCascading == 0
            ) {
                if(SpinModel.stopImmediately || remainingTime<=0 ) {

                    this.allowStop();
                } else {
                    this.addDelayedCall(remainingTime/1000, this.allowStop, [], this);
                }
            }
        }
    }

    public popSymbols(winningSymbols?: boolean[][]) {
        const frames = this.assets.generateFrames(
            "explode" + "_",
            3,
            GameModel.gameConfig.animData["explode"].numFrames
        );
        const winningPositions =
            winningSymbols || SpinModel.getCurrentCascadeExplodeMap();
        this.popAnimationSprites = [];
        for (let i = 0; i < winningPositions.length; i++) {
            for (let j = 0; j < winningPositions[i].length; j++) {
                if (winningPositions[i][j]) {
                    const winningSymbol = this.reels[i].symbols[j];
                    this.poppedSymbols.push(winningSymbol);
                    winningSymbol.visible = false;

                    const sprite = new PIXI.extras.AnimatedSprite(frames);
                    sprite.animationSpeed = GameModel.gameConfig.popAnimSpeed;
                    this.popAnimationSprites.push(sprite);
                    sprite.anchor.set(0.5, 0.5);
                    sprite.loop = false;
                    sprite.position.x = winningSymbol.position.x;
                    sprite.position.y = winningSymbol.position.y;
                    sprite.width = winningSymbol.width * 2;
                    sprite.height = winningSymbol.height * 2;
                    this.symContainer.addChild(sprite);
                    sprite.gotoAndPlay(0);
                }
            }
        }

        if (this.popAnimationSprites.length > 0) {
            this.popAnimationSprites[
                this.popAnimationSprites.length - 1
            ].onComplete = () => {
                this.popAnimationSprites.forEach((anim) => {
                    anim.destroy();
                });
                this.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED);
            };
        } else {
            this.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED);
        }
    }

    public removePopAnimations() {
        for (let i = 0; i < this.popAnimationSprites.length; i++) {
            this.symContainer.removeChild(this.popAnimationSprites[i]);
        }
        this.popAnimationSprites = [];
    }

    public restorePoppedSymbols() {
        for (let i = 0; i < this.poppedSymbols.length; i++) {
            this.poppedSymbols[i].visible = true;
        }
        this.poppedSymbols = [];
    }

    public showFinalSymbols() {
        // override with empty
    }

    protected stopReels() {
        if (this.stoppingStarted) {
            return;
        }
        this.stoppingStarted = true;
        let delay = 0;
        let symbols = SpinModel.getCurrentFinalSymbols();

        // TODO:  If this is a re-spin - get the correct symbols
        //if (this.isRespin) {
        // symbols = SpinModel.getNextGenSymbols();
        //}

        // Loop through the reels and stop each
        this.spinners.forEach((spinnerBehavior, reelIdx) => {
            if (this.isRespin && !this.lastRemovedSymbols[reelIdx]) {
                return;
            }

            const reel = this.reels[reelIdx];
            reel.once(
                GameEvents.REEL_STOPPED,
                () => this.onReelStopped(reelIdx),
                this
            );

            // Put a delay between reel stops - grows for each reel
            // If we have anticipation - longer delay should be used

            let anticipationData = SpinModel.getCurrentSpinProperty(
                "spinification"
            );

            if (
                anticipationData &&
                anticipationData.spinificationIndex <= reelIdx &&
                anticipationData.spinificationEndIndex >= reelIdx
            ) {
                console.log("Anticipate reel -> " + reelIdx, anticipationData);
                this.hasAnticipation = true;
                spinnerBehavior.activateAnticipation();
                delay += reelIdx * App.config.reelSpinificationDuration;
            } else {
                delay += reelIdx * this.config.cascadeAnimation.reelDelayTime;
            }
            spinnerBehavior.animationStartDelay = delay;

            // Then stop the reel
            spinnerBehavior.stop(symbols[reelIdx]);
        });

        // Notify that reel stopping has started
        this.dispatcher.emit(GameEvents.REEL_STOP_STARTED);

        // End the cascade flag
        this.inCascade = false;
    }

    public stopImmediately(e: any) {
        SpinModel.stopImmediately = true;
        for (let reelIdx = 0; reelIdx < this.spinners.length; reelIdx++) {
            const s = this.spinners[reelIdx];
            s.activateQuickStop();
        }
    }

    public onReelStopped(reelIdx: number) {
        this.reelsSpinning--;
        this.dispatcher.emit(GameEvents.REEL_STOPPED, reelIdx); // used in idleParticlesController
        if (this.reelsSpinning == 0) {
            this.dispatcher.emit(GameEvents.ALL_REELS_STOPPED);
        }
    }

    public displayBonusResult(
        winlinesToShow: IWinData[],
        firstWildIndex,
        wildVersion
    ) {
        winlinesToShow.forEach((winline) => {
            this.highlightWinlineWin(winline, false);
            this.winlinesView.highlightWinLine(winline, false);
        });
        this.on(GameEvents.GROUP_ANIM_COMPLETE, () => {
            this.finishShowingWinlines();
            winlinesToShow.forEach((winline) => this.hideWinlineWin(winline));
        });
    }
}

export default CascadeReelGroup;
